export default {
  cardHeader: {
    paddingRight: 0
  },
  markerList: {
    padding: 0,
    marginBottom: 16,
    border: "1px solid #ededed"
  },
  toggleContainer: {
    paddingRight: 25
  }
};



// WEBPACK FOOTER //
// ./src/pages/Map/style.js